module.exports = __webpack_public_path__ + "static/media/team-img3.d018eda8.jpg";